import React from "react";
import { Box, Typography } from "@mui/material";

const CHIP_COLORS = {
  5:     { bg: "#f5f5f5", border: "#9e9e9e", text: "#212121" },
  10:    { bg: "#1565c0", border: "#0d47a1", text: "#fff" },
  20:    { bg: "#00838f", border: "#006064", text: "#fff" },
  25:    { bg: "#2e7d32", border: "#1b5e20", text: "#fff" },
  50:    { bg: "#e65100", border: "#bf360c", text: "#fff" },
  100:   { bg: "#212121", border: "#000",    text: "#fff" },
  200:   { bg: "#6a1b9a", border: "#4a148c", text: "#fff" },
  500:   { bg: "#c62828", border: "#b71c1c", text: "#fff" },
  1000:  { bg: "#f9a825", border: "#f57f17", text: "#212121" },
  2000:  { bg: "#ad1457", border: "#880e4f", text: "#fff" },
  5000:  { bg: "#e65100", border: "#bf360c", text: "#fff" },
  10000: { bg: "#4527a0", border: "#311b92", text: "#fff" },
  25000: { bg: "#ece6ef", border: "#212121", text: "#212121" },
};

const CHIP_IMAGES = {
  100:   "/chips/chip-100.jpeg",
  500:   "/chips/chip-500.jpeg",
  1000:  "/chips/chip-1000.jpeg",
  5000:  "/chips/chip-5000.jpeg",
  10000: "/chips/chip-10000.jpeg",
  25000: "/chips/chip-25000.jpeg",
};

const DEFAULT_COLOR = { bg: "#546e7a", border: "#37474f", text: "#fff" };

export const getChipColor = (denomination) =>
  CHIP_COLORS[Number(denomination)] || DEFAULT_COLOR;

export default function ChipToken({ denomination, size = 44, isPromo = false }) {
  const val = Number(denomination);
  const imgSrc = !isPromo && CHIP_IMAGES[val];
  const label = val >= 1000 ? `${val / 1000}K` : `${val}`;

  if (imgSrc) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.4, flexShrink: 0 }}>
        <Box
          component="img"
          src={imgSrc}
          alt={`${val} chip`}
          sx={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", display: "block" }}
        />
        <Typography fontWeight={700} sx={{ fontSize: size * 0.28, lineHeight: 1, color: "text.primary", userSelect: "none" }}>
          {val >= 1000 ? `${val / 1000}K` : val}
        </Typography>
      </Box>
    );
  }

  const { bg, border, text } = getChipColor(denomination);
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        bgcolor: bg,
        border: `3px solid ${border}`,
        outline: `2px dashed ${border}44`,
        outlineOffset: -6,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <Typography
        fontWeight={800}
        sx={{ color: text, fontSize: size * 0.27, lineHeight: 1, userSelect: "none" }}
      >
        {label}
      </Typography>
    </Box>
  );
}
